import React, {
  useState,
} from 'react';
import {
  shallowEqual,
  useDispatch,
  useSelector,
} from 'react-redux';
import Modal from 'react-modal';

import {
  coreActions,
  coreSelectors,
} from '@gymcloud/core';

import {
  Icon,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

import * as S from './styled';

const link = 'https://www.youtube.com/embed/VOhrl6xH1TQ?autoplay=1&amp;enablejsapi=1&amp;version=3&amp;playerapiid=ytplayer';

const getCustomStyles = {
  overlay: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    overflow: 'hidden auto',
    paddingBottom: '50px',
    width: '100%',
    zIndex: 9999,
  },
  content: {
    padding: 0,
    borderRadius: 0,
    background: 'none',
    position: 'relative',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    marginTop: '50px',
    marginBottom: 'auto',
    width: '100%',
    border: 'none',
    outline: 'none',
    overflow: 'visible',
  },
};

const mapState = state => ({
  userSettings: coreSelectors.getProfile('user_settings')(state),
});

const OnboardingVideo = () => {
  const dispatch = useDispatch();
  const { userSettings } = useSelector(mapState, shallowEqual);
  const steps = userSettings.tutorial_steps;

  const videoSeen = userSettings.web_onboarding_video_seen;
  const [isOpen, setOpen] = useState(!videoSeen);

  const handleUpdateSetting = (body) => {
    dispatch(
      coreActions.requestUpdateSettings({
        body,
        settingsId: userSettings.id,
      }),
    );
  };

  const handleUpdateVideoSeen = (e) => {
    e.stopPropagation();
    handleUpdateSetting({
      tutorial_steps: [
        ...steps,
        'video_tutorial',
      ],
    });
  };

  const close = () => {
    setOpen(false);
    handleUpdateSetting({
      web_onboarding_video_seen: true,
    });
  };

  return steps.indexOf('video_tutorial') !== -1 ? null : (
    <>
      <S.Play onClick={() => setOpen(true)}>
        Watch The Tutorial
        <S.Remove
          onClick={handleUpdateVideoSeen}
        >
          <Icon
            type="fas fa-times"
          />
        </S.Remove>
      </S.Play>
      <Modal
        style={getCustomStyles}
        ariaHideApp={false}
        onRequestClose={close}
        isOpen={isOpen}
        bodyOpenClassName="onboarding-video-open"
      >
        <S.ModalContent>
          <Flex
            clickable
            alignSelf="flex-start"
            onClick={close}
          >
            <Icon
              type="fas fa-times"
              size="28px"
              color="#aaaaa9"
            />
          </Flex>
          <S.Video>
            <S.Frame
              src={link}
              allow="autoplay"
              webkitallowfullscreen=""
              mozallowfullscreen=""
              allowFullScreen=""
            />
          </S.Video>
        </S.ModalContent>
      </Modal>
    </>
  );
};

export default OnboardingVideo;
